import { IPriceCalculationInfo } from '../journey/journey';

export enum TravelAddonType {
  MeetGreet = 'MEET_GREET',
  BabySeat = 'BABY_SEAT',
  ChildSeat = 'CHILD_SEAT',
  BoosterSeat = 'BOOSTER_SEAT',
  Pets = 'PETS',
  ExtraStop = 'EXTRA_STOP',
  SpecialLuggage = 'SPECIAL_LUGGAGE',
  CarbonEmissionCompensation = 'CARBON_EMISSION_COMPENSATION',
}

export const TravelAddonTypeDisplayName = {
  [TravelAddonType.MeetGreet]: 'Meet & greet',
  [TravelAddonType.BabySeat]: 'Baby seat',
  [TravelAddonType.ChildSeat]: 'Child seat',
  [TravelAddonType.BoosterSeat]: 'Booster seat',
  [TravelAddonType.Pets]: 'Pets',
  [TravelAddonType.ExtraStop]: 'Extra stop',
  [TravelAddonType.SpecialLuggage]: 'Special luggage',
  [TravelAddonType.CarbonEmissionCompensation]: 'Carbon emission compensation',
};

export interface TravelAddon {
  type: string;
  amount?: number;
  priceCalculationInfo?: IPriceCalculationInfo;
}
